import React, { useState, useContext } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import Header from './header';
import darkRoadHeader from './Assets/darkRoadImage.png';
import platform from './Assets/end2end1.png'
import upload from './Assets/upload.png';
import scan from './Assets/scan1.png';
import visualize from './Assets/visualize.png';
import mapping from './Assets/mapping.png';
import chart from './Assets/chart.png';
import distribute from './Assets/distribute.png';
import onstation from './Assets/OnStationWhite.png';
import Footer from './footer';
import { AuthContext } from '../../context/AuthContext';
import HQDemo from './hqDemo';


const IconPlay = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
  </svg>
);

const IconClipboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
    <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
  </svg>
);

const IconClock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
  </svg>
);

const IconPuzzle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" />
  </svg>
);

const IconChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

const IconLightning = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
  </svg>
);

const IconDesktop = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clipRule="evenodd" />
  </svg>
);

const VideoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-stone-900 w-full max-w-4xl rounded-xl overflow-hidden shadow-2xl">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 z-10 bg-stone-800 p-2 rounded-full text-white hover:text-yellow-500 transition-colors"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
        <div className="aspect-video w-full">
          <iframe
            src="https://www.youtube.com/embed/uKgasSdowUM?autoplay=1&controls=1&showinfo=0&rel=0&modestbranding=1"
            className="w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
            allowFullScreen
            title="TransTech Connect Demo"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

const DemoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black" onClick={onClose}></div>
      
      {/* Demo Container */}
      <div className="relative w-full h-full">
        {/* Close button overlay */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 z-50 bg-gray-900/80 backdrop-blur-sm p-3 rounded-full text-white hover:text-yellow-500 hover:bg-gray-800 transition-all duration-200 shadow-lg"
          title="Close Demo"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
        
        {/* Demo Content */}
        <React.Suspense fallback={
          <div className="flex items-center justify-center h-screen bg-gray-800">
            <div className="text-white text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-400 mx-auto mb-4"></div>
              <div className="text-lg font-semibold">Loading Interactive Demo...</div>
              <div className="text-sm text-gray-400 mt-2">Preparing sample measurement data</div>
            </div>
          </div>
        }>
          <HQDemo />
        </React.Suspense>
      </div>
    </div>
  );
};

const LandingPage = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);

  // Handle scroll animations
  const observerRef = React.useRef(null);
  
  React.useEffect(() => {
    // Check if device is desktop
    const checkIsDesktop = () => {
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isMobileWidth = window.innerWidth < 1024; // lg breakpoint
      setIsDesktop(!isMobileUserAgent && !isMobileWidth);
    };

    checkIsDesktop();
    window.addEventListener('resize', checkIsDesktop);

    // Simple intersection observer setup for scroll animations
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, { threshold: 0.1 });
    
    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observerRef.current.observe(el);
    });
    
    return () => {
      window.removeEventListener('resize', checkIsDesktop);
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const openDemo = () => {
    if (!isDesktop) {
      return;
    }
    // Track demo opens if you have analytics
    // gtag('event', 'demo_opened', { event_category: 'engagement' });
    setIsDemoOpen(true);
  };

  const handlePlatformClick = () => {
    if (isDesktop) {
      openDemo();
    }
  };

  return (
    <div className="bg-black text-white font-sans">
      <Header />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center sm:pt-16">
        <div className="absolute inset-0 -z-10">
          <img 
            src={darkRoadHeader} 
            alt="Asphalt road" 
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
        </div>
        
        <div className="container mx-auto px-6 py-24 md:py-20">
          <div className="max-w-3xl mx-auto">
            <div className="flex flex-wrap gap-3 mb-8">
              

              <div className="inline-flex gap-1 items-center bg-yellow-500/20 backdrop-blur-sm border border-yellow-500/40 rounded-full px-4 py-2 text-sm text-yellow-300">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
          14 days free • No card required
        </div>
            </div>

            
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-6">
              Data Management for Your Asphalt Jobs
            </h1>
            
            <p className="text-xl text-gray-300 mb-12 max-w-2xl">
              Eliminate clipboards and errors. Measure, scan, and manage your asphalt density data with precision and ease.
            </p>
            

            
            <div className="flex flex-wrap gap-4">
        {isAuthenticated ? (
          <a href="/dashboard" className="bg-yellow-500 hover:bg-yellow-400 text-black font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-yellow-500/20">
            Go to Dashboard
          </a>
        ) : (
          <>
            {isDesktop && (
              <button 
                onClick={openDemo}
                className="bg-yellow-500 hover:bg-yellow-400 text-black font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-yellow-500/20 flex items-center"
              >
                <IconLightning className="w-5 h-5 mr-2" />
                Try Interactive Demo
              </button>
            )}
            
            {/* UPDATED - Enhanced Free Trial Button */}
              <a href="/onboarding" className="bg-transparent border border-white/30 hover:border-white/60 text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 text-center">
                Get Started
                <span aria-hidden="true" className="ml-2">→</span>
              </a>
              
            
           
          </>
        )}
      </div>
          </div>
          
          <div className="mt-16 md:mt-24 max-w-5xl mx-auto">
            <div className="relative flex justify-center">
              <div 
                className={`bg-gradient-to-r from-yellow-500/20 to-stone-700/20 backdrop-blur-md rounded-xl p-1 shadow-2xl w-full transition-all duration-300 ${
                  isDesktop 
                    ? 'cursor-pointer hover:from-yellow-500/30 hover:to-stone-700/30 group' 
                    : 'cursor-default'
                }`}
                onClick={handlePlatformClick}
              >
                <img 
                  src={platform} 
                  alt="TransTech Connect Platform Preview" 
                  className="w-full rounded-lg"
                />
                
                {/* Overlay with play button - only show on desktop */}
                {isDesktop && (
                  <div className="absolute inset-0 bg-black/40 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="bg-yellow-500 text-black p-6 rounded-full shadow-lg transform group-hover:scale-110 transition-transform duration-300">
                      <IconLightning className="h-8 w-8" />
                    </div>
                    <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-black/80 text-white px-4 py-2 rounded-lg text-sm font-medium">
                      Click to try interactive demo
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PDF Reports Section - NEW - RIGHT UNDER HERO */}
      <section id="reporting" className="py-16 md:py-20 lg:py-24 bg-gradient-to-b from-black to-stone-900">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
              {/* Content */}
              <div className="order-2 lg:order-1 animate-on-scroll">
                <div className="mb-6">
                  <span className="inline-flex items-center text-yellow-500 font-semibold uppercase tracking-wide text-xs sm:text-sm bg-yellow-500/10 px-3 py-1 rounded-full">
                    <IconLightning className="h-2 w-2 mr-2" />
                    New Feature
                  </span>
                  <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-3 mb-4 leading-tight">
                    Professional PDF Reports
                  </h2>
                  <p className="text-lg sm:text-xl text-gray-300 leading-relaxed">
                    Generate comprehensive compaction reports with map visualization, detailed analysis, and professional formatting in seconds.
                  </p>
                </div>
                
                <div className="space-y-4 sm:space-y-5 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-yellow-500/20 rounded-full flex items-center justify-center mt-0.5">
                      <span className="text-yellow-500 text-sm font-bold">✓</span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-white font-semibold text-base sm:text-lg">Static Site Map</h4>
                      <p className="text-gray-400 text-sm sm:text-base mt-1">GPS-tagged measurements with pass/fail visualization</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-yellow-500/20 rounded-full flex items-center justify-center mt-0.5">
                      <span className="text-yellow-500 text-sm font-bold">✓</span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-white font-semibold text-base sm:text-lg">Quality Control Summary</h4>
                      <p className="text-gray-400 text-sm sm:text-base mt-1">Automated pass rates, averages, and compliance metrics</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 bg-yellow-500/20 rounded-full flex items-center justify-center mt-0.5">
                      <span className="text-yellow-500 text-sm font-bold">✓</span>
                    </div>
                    <div className="min-w-0 flex-1">
                      <h4 className="text-white font-semibold text-base sm:text-lg">Operator Performance</h4>
                      <p className="text-gray-400 text-sm sm:text-base mt-1">Individual statistics and detailed measurement tables</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <a 
                  href="https://zccgzqkkpmqpawelftbw.supabase.co/storage/v1/object/public/sample-files//Sample-Compaction-Report-TTechConnect.pdf"  // UPDATE: Point to your PDF file
                  target="_blank"                       // Opens in new tab
                  rel="noopener noreferrer"            // Security best practice
                  className="w-full sm:w-auto bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-semibold py-3 px-6 rounded-lg transition-all duration-300 text-center touch-manipulation flex items-center justify-center"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                  </svg>
                  See Sample Report
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 ml-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </a>
                </div>
              </div>
              
              {/* Visual */}
              <div className="order-1 lg:order-2 animate-on-scroll">
                <div className="relative mx-auto max-w-md lg:max-w-none">
                  <div className="bg-gradient-to-br from-yellow-500/20 to-stone-700/20 backdrop-blur-md rounded-xl p-3 sm:p-4 shadow-2xl">
                    {/* PDF Report Preview - Mobile Optimized */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-lg">
                      <div className="h-64 sm:h-72 md:h-80 bg-gray-50 p-3 sm:p-4">
                        {/* Header */}
                        <div className="flex items-center justify-between mb-3">
                          <div className="text-xs sm:text-sm font-bold text-gray-800">COMPACTION REPORT</div>
                          <div className="w-8 h-4 bg-yellow-400 rounded"></div>
                        </div>
                        
                        {/* Project Info */}
                        <div className="space-y-1 mb-4">
                          <div className="h-2 bg-gray-300 rounded w-3/4"></div>
                          <div className="h-2 bg-gray-300 rounded w-1/2"></div>
                        </div>
                        
                        {/* Map Section */}
                        <div className="bg-gradient-to-br from-green-100 to-blue-100 rounded-lg p-3 sm:p-4 mb-3 relative">
                          <div className="text-xs font-semibold text-gray-700 mb-2">SITE MAP</div>
                          <div className="relative h-20 sm:h-24 bg-green-200 rounded flex items-center justify-center">
                            {/* Simulated map with markers */}
                            <div className="absolute inset-0 flex items-center justify-center">
                              <div className="grid grid-cols-4 gap-1">
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                              </div>
                            </div>
                          </div>
                          
                          {/* Legend */}
                          <div className="flex items-center gap-3 mt-2 text-xs">
                            <div className="flex items-center gap-1">
                              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                              <span className="text-gray-600">Pass</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                              <span className="text-gray-600">Fail</span>
                            </div>
                          </div>
                        </div>
                        
                        {/* Data Table Preview */}
                        <div className="space-y-1">
                          <div className="text-xs font-semibold text-gray-700">QUALITY SUMMARY</div>
                          <div className="grid grid-cols-3 gap-1">
                            <div className="h-1.5 bg-gray-300 rounded"></div>
                            <div className="h-1.5 bg-green-300 rounded"></div>
                            <div className="h-1.5 bg-red-300 rounded"></div>
                          </div>
                          <div className="grid grid-cols-3 gap-1 mt-1">
                            <div className="h-1.5 bg-gray-300 rounded"></div>
                            <div className="h-1.5 bg-gray-300 rounded"></div>
                            <div className="h-1.5 bg-gray-300 rounded"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Floating elements */}
                  <div className="absolute -right-2 -top-2 sm:-right-4 sm:-top-4 bg-yellow-500 text-black px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-bold shadow-lg">
                    NEW
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Two Usage Methods Section */}
      <section className="py-20 md:py-12 bg-gradient-to-b from-stone-900 to-black">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Choose Your Connection Method</h2>
            <p className="text-lg text-gray-300">
              Works with existing PQI 380 gauges or upgrade to instant mobile scanning
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
            {/* PQI 380 Standard */}
            <div className="bg-stone-800 rounded-xl p-4 md:p-6 text-center">
              <div className="h-48 md:h-60 mb-4 rounded-lg overflow-hidden">
                <img src={upload} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2">PQI 380</h3>
              <p className="text-sm md:text-base text-gray-300 mb-4">Export CSV → Upload → Analyze</p>
              <div className="text-xs md:text-sm text-yellow-500 font-medium">
                ✓ Use existing equipment ✓ Batch upload
              </div>
            </div>
            
            {/* PQI 380+ */}
            <div className="relative bg-stone-800 rounded-xl p-4 md:p-6 text-center border-2 border-yellow-500">
              <div className="absolute top-2 right-2 md:top-3 md:right-3 bg-yellow-500 text-black text-xs px-2 py-1 rounded font-semibold">
                RECOMMENDED
              </div>
              <div className="h-48 md:h-60 mb-4 rounded-lg overflow-hidden">
                <img src={scan} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2"><span className="italic">NEW</span> PQI 380+</h3>
              <p className="text-sm md:text-base text-gray-300 mb-4">Scan QR → Instant Upload → Real-time</p>
              <div className="text-xs md:text-sm text-yellow-500 font-medium">
                ✓ Zero manual entry ✓ Real time data
              </div>
            </div>
          </div>
            
          <div className="max-w-4xl mx-auto mt-12 text-center animate-on-scroll">
            <div className="bg-gradient-to-br from-yellow-500/10 to-yellow-600/10 p-6 rounded-lg border border-yellow-500/20">
              <h3 className="text-xl font-bold text-white mb-4">See how both methods work in our interactive demo</h3>
              <p className="text-gray-300 mb-6">
                Experience the complete workflow from data collection to analysis with real sample data.
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a 
                  href="#contact" 
                  className="inline-flex items-center bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-medium py-2 px-6 rounded-lg transition-all duration-300"
                >
                  Contact Sales
                  <IconChevronRight className="h-4 w-4 ml-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
        
      {/* Problem Section */}
      <section id="challenges" className="py-20 md:py-12 bg-gradient-to-b from-stone-900 to-black">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center mb-16 animate-on-scroll">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">The Challenges</h2>
            <p className="text-xl text-gray-300">
              Construction teams struggle with inefficient data collection and management for asphalt projects.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-stone-800 to-stone-900 rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="bg-stone-800 p-4 inline-flex rounded-lg mb-4">
                <IconClipboard className="w-8 h-8 text-yellow-500" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Manual Data Entry</h3>
              <p className="text-gray-300">
                Field crews waste valuable time manually recording measurements, introducing costly errors and delays.
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-stone-800 to-stone-900 rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="bg-stone-800 p-4 inline-flex rounded-lg mb-4">
                <IconClock className="w-8 h-8 text-yellow-500" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Delayed Insights</h3>
              <p className="text-gray-300">
                Project managers can't access real-time data, making it impossible to make critical decisions when they matter most.
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-stone-800 to-stone-900 rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="bg-stone-800 p-4 inline-flex rounded-lg mb-4">
                <IconPuzzle className="w-8 h-8 text-yellow-500" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Disconnected Systems</h3>
              <p className="text-gray-300">
                Multiple tools and platforms create silos that prevent true project visibility and collaboration.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="relative py-24 md:py-12">
        <div className="absolute inset-0 -z-10">
          <img src={darkRoadHeader} alt="Dark road background" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black"></div>
        </div>
        
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center mb-16 animate-on-scroll">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Powerful Features</h2>
            <p className="text-xl text-gray-300">
              A complete platform designed for every step of your asphalt density management workflow.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Feature 1: Visualize */}
            <div className="bg-gradient-to-br from-stone-800/70 to-stone-900/70 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="flex items-start mb-6">
                <div className="bg-yellow-500/20 p-4 rounded-lg mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Visualize</h3>
              </div>
              
              <p className="text-gray-300 mb-6">
                See all your asphalt density measurements in real-time on interactive maps. Filter by date, project, or measurement type for complete visibility.
              </p>
              
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Interactive heatmap visualization</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">GPS-tagged measurements</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Measurement sequence tracking</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Real-time data synchronization</span>
                </li>
              </ul>
              
              <div className="h-48 bg-stone-800 rounded-lg overflow-hidden">
                <img 
                  src={visualize}
                  alt="Map visualization interface" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
            
            {/* Feature 2: Projects */}
            <div className="bg-gradient-to-br from-stone-800/70 to-stone-900/70 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="flex items-start mb-6">
                <div className="bg-yellow-500/20 p-4 rounded-lg mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z" clipRule="evenodd" />
                    <path d="M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Project Mapping</h3>
              </div>
              
              <p className="text-gray-300 mb-6">
                Organize measurements into logical projects using our smart map process with geofencing. Automatically assign measurements to the correct project.
              </p>
              
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Automated geofencing</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Central data storage</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Hold Project details</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Progress tracking</span>
                </li>
              </ul>
              
              <div className="h-48 bg-stone-800 rounded-lg overflow-hidden">
                <img 
                  src={mapping}
                  alt="Project management interface" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
            
            {/* Feature 3: Analyze */}
            <div className="bg-gradient-to-br from-stone-800/70 to-stone-900/70 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="flex items-start mb-6">
                <div className="bg-yellow-500/20 p-4 rounded-lg mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-2 2a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Analyze</h3>
              </div>
              
              <p className="text-gray-300 mb-6">
                Comprehensive analytics tools help you assess data for compliance with project specifications. Identify potential issues before they become problems.
              </p>
              
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Compliance monitoring</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Statistical analysis tools</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Customizable thresholds</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Trend identification</span>
                </li>
              </ul>
              
              <div className="h-48 bg-stone-800 rounded-lg overflow-hidden">
                <img 
                  src={chart}
                  alt="Analytics dashboard" 
                  className="w-full h-full object-cover object-left-top"
                />
              </div>
            </div>
            
            {/* Feature 4: Distribute */}
            <div className="bg-gradient-to-br from-stone-800/70 to-stone-900/70 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-yellow-500/10 transition-all duration-300 animate-on-scroll">
              <div className="flex items-start mb-6">
                <div className="bg-yellow-500/20 p-4 rounded-lg mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white">Distribute</h3>
              </div>
              
              <p className="text-gray-300 mb-6">
                Share your data seamlessly with stakeholders through our partner integrations. Export to OnStation and other platforms with just a few clicks.
              </p>
              
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">OnStation integration</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">PDF report generation</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">CSV/Excel exports</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-500 mr-2">✓</span>
                  <span className="text-gray-300">Secure data sharing</span>
                </li>
              </ul>
              
              <div className="h-48 bg-stone-800 rounded-lg overflow-hidden">
                <img 
                  src={distribute} 
                  alt="Data sharing interface" 
                  className="w-full h-full object-cover object-left-top"
                />
              </div>
            </div>
          </div>
          
          <div className="max-w-4xl mx-auto mt-16 text-center animate-on-scroll">
            <div className="flex flex-wrap gap-4 justify-center">
              {isDesktop ? (
                <>
                  <button
                    onClick={openDemo}
                    className="inline-flex items-center bg-yellow-500 hover:bg-yellow-400 text-black font-medium py-3 px-8 rounded-lg transition-colors duration-300 shadow-lg shadow-yellow-500/20"
                  >
                    <IconLightning className="h-5 w-5 mr-2" />
                    Try Interactive Demo
                  </button>
                  <a 
                    href="/signup"
                    className="inline-flex items-center bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-medium py-3 px-8 rounded-lg transition-colors duration-300"
                  >
                    Start Free Trial
                    <IconChevronRight className="h-5 w-5 ml-2" />
                  </a>
                </>
              ) : (
                <>
                  <a 
                    href="/signup"
                    className="inline-flex items-center bg-yellow-500 hover:bg-yellow-400 text-black font-medium py-3 px-8 rounded-lg transition-colors duration-300 shadow-lg shadow-yellow-500/20"
                  >
                    Start Free Trial
                    <IconChevronRight className="h-5 w-5 ml-2" />
                  </a>
                  <a
                    href="https://transtechsys.com/products/salesRequest"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-medium py-3 px-8 rounded-lg transition-colors duration-300"
                  >
                    Contact Sales
                    <IconChevronRight className="h-5 w-5 ml-2" />
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      
        
      {/* In the Press Section */}
      <section className="bg-stone-900 py-12 md:py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center mb-10 animate-on-scroll">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">In the Press</h2>
            <p className="text-lg text-gray-300">
              Recent coverage of TransTech Connect and our industry-leading integrations
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
            {/* Press Item 3 - OnStation Announcement */}
            <div className="md:col-span-2 bg-gradient-to-br from-stone-800 to-stone-900 rounded-xl p-6 border border-stone-700/50 shadow-lg hover:shadow-xl transition-all duration-300 animate-on-scroll">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="flex-shrink-0 p-4 bg-stone-800 rounded-xl">
                  <img src={onstation} alt="OnStation Logo" className="h-12 md:h-16 w-auto" />
                </div>
                
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h3 className="text-xl font-bold text-white">OnStation Integration Announced</h3>
                    <span className="text-xs font-medium bg-yellow-500/20 text-yellow-500 py-1 px-2 rounded">New at WOA 2025</span>
                  </div>
                  
                  <p className="text-gray-300 mb-4">
                    Our new integration with OnStation allows seamless transmission of non-nuclear density readings from TransTech Connect to the OnStation Portal. Eliminate manual entry, reduce errors, and access live, geotagged data.
                  </p>
                  
                  <div className="flex flex-wrap items-center gap-4">
                    <a
                      href="https://finance.yahoo.com/news/transforming-construction-data-onstation-integrates-141100441.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-yellow-500 font-medium hover:text-yellow-400 transition-colors"
                    >
                      Read Press Release
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </a>
                    
                    <a
                      href="/integrations"
                      className="inline-flex items-center text-yellow-500 font-medium hover:text-yellow-400 transition-colors"
                    >
                      View Integration Details
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        
      {/* Call to Action */}
      <section id="contact" className="relative py-24 md:py-32">
        <div className="absolute inset-0 -z-10">
          <img src={darkRoadHeader} alt="Dark road background" className="h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/90 to-black/70"></div>
        </div>
        
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-stone-800/80 to-stone-900/80 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-stone-700/30 shadow-2xl animate-on-scroll">
              <div className="text-center mb-10">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Ready to Transform Your Workflow?</h2>
                <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                  Experience our interactive demo, start your free trial, or schedule a personalized demo to see how TransTech Connect can work for your specific needs.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                
                
                <div className="bg-stone-800/80 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 text-center hover:border-yellow-500/30 transition-all duration-300">
                  <h3 className="text-xl font-bold text-white mb-3">Start Free Trial</h3>
                  <p className="text-gray-300 mb-6">
                    Get immediate access and start on you own.
                  </p>
                  {isAuthenticated ? (
                    <a href="/dashboard" className="inline-block w-full bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-medium py-3 px-6 rounded-lg transition-colors duration-300">
                      Go to Dashboard
                    </a>
                  ) : (
                    <a href="/signup" className="inline-block w-full bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-medium py-3 px-6 rounded-lg transition-colors duration-300">
                      Start Now
                    </a>
                  )}
                </div>
                
                <div className="bg-stone-800/80 backdrop-blur-sm rounded-xl p-6 border border-stone-700/50 text-center hover:border-yellow-500/30 transition-all duration-300">
                  <h3 className="text-xl font-bold text-white mb-3">Schedule Demo</h3>
                  <p className="text-gray-300 mb-6">
                    Get a personalized walkthrough with our team.
                  </p>
                  <a
                    href="https://transtechsys.com/products/salesRequest"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-full bg-transparent border border-gray-500 text-gray-300 hover:bg-gray-500 hover:text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300"
                  >
                    Contact Sales
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <Footer />
      
      {/* Modals */}
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />
      <DemoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
    </div>
  );
};

export default LandingPage;